export default [
  'Individual (individu)',
  'Institution (institusi/lembaga)',
  'Government (pemerintah)',
  'International Institution (lembaga internasional)',
  'NGO (LSM)',
  'Others (lainnya)'
];
